import {Checkbox, Radio} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {compose} from 'redux';
import SAInputNumber from '../common/input/SAInputNumber';
import SAInputPercentage from '../common/input/SAInputPercentage';
import {fetchDealerPlanningConfiguration, saveDealerPlanningConfiguration} from '../../actions/planningConfigurationActions';
import {SpinnerModal} from '../../public/components/SpinnerModal';
import {selectDealerPlanningLoading, selectFetchDealerPlanningConfiguration, selectSaveDealerPlanningConfiguration} from '../../selectors/planningConfigurationSelector';
import {withAuthorization} from '../../services/Authorization';
import Storage from '../../services/Storage';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class PlanningConfiguration extends React.Component {

  static propTypes = {
    dispatchFetchDealerPlanningConfiguration: PropTypes.func.isRequired,
    dispatchSaveDealerPlanningConfiguration: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {
      planningConfiguration: {
        dmsLinkConfiguration: {}
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const fetchPlanningConfiguration = nextProps.fetchDealerPlanningConfiguration && nextProps.fetchDealerPlanningConfiguration.planningConfiguration;
    if (fetchPlanningConfiguration && fetchPlanningConfiguration !== prevState.planningConfiguration) {
      return {planningConfiguration: fetchPlanningConfiguration};
    }
    const savePlanningConfiguration = nextProps.saveDealerPlanningConfiguration && nextProps.saveDealerPlanningConfiguration.planningConfiguration;
    if (savePlanningConfiguration && Object.keys(savePlanningConfiguration).length && savePlanningConfiguration !== prevState.planningConfiguration) {
      return {planningConfiguration: savePlanningConfiguration};
    }
    return null; // no change
  }

  componentDidMount() {
    this.props.dispatchFetchDealerPlanningConfiguration();
  }

  handleDmsLinkEnabledChange = (e) => {
    const {planningConfiguration} = this.state;
    planningConfiguration.dmsLinkConfiguration.enabled = e.target.checked;
    this.setState(planningConfiguration);
  }

  handleDmsLinkBookingCapacityLimitChange = (e) => {
    const {planningConfiguration} = this.state;
    planningConfiguration.dmsLinkConfiguration.bookingCapacityLimit = e.target.value;
    this.setState(planningConfiguration);
  }

  handleDmsLinkMaxOnlineBookingCapacityChange = (e) => {
    const {planningConfiguration} = this.state;
    planningConfiguration.dmsLinkConfiguration.maxOnlineBookingCapacity = e;
    this.setState(planningConfiguration);
  }

  handleDmsLinkMinOpenBufferChange = (e) => {
    const {planningConfiguration} = this.state;
    planningConfiguration.dmsLinkConfiguration.minOpenBuffer = e;
    this.setState(planningConfiguration);
  }

  save = () => {
    this.props.dispatchSaveDealerPlanningConfiguration(this.state.planningConfiguration);
  }

  render() {
    const {intl: {formatMessage}, loading, saveDealerPlanningConfiguration} = this.props;
    const dmsLinkConfiguration = this.state.planningConfiguration.dmsLinkConfiguration;
    const canWrite = Storage.getItem('user').role === 'DUI_ADMIN';
    const {error: {content: errors = {}} = {}} = saveDealerPlanningConfiguration;

    return (
      <section className='box'>
        <header className='box-heading'>
          <h2 className='box-heading__title'>
            {formatMessage({id: 'section.planning-configuration.title'})}
          </h2>
          {canWrite && (
            <div className='box-heading__button'>
              <button onClick={this.save} disabled={loading} type='primary' className='btn btn-sm btn-primary'>
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          )}
        </header>
        <div className='box__body'>
          <SpinnerModal visible={loading}/>

          <div className='row'>
            <div className='col-sm-12 col-xxl-6'>
              <h3 className='box__subtitle'>
                {formatMessage({id: 'section.planning-configuration.dms-link.title'})}
              </h3>
              <Checkbox name='enabled' checked={dmsLinkConfiguration && dmsLinkConfiguration.enabled} disabled={!canWrite} onChange={this.handleDmsLinkEnabledChange}>
                {formatMessage({id: 'section.planning-configuration.dms-link.enabled'})}
              </Checkbox>
            </div>

            <div className='col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0'>

              <h3 className='box__subtitle'>{formatMessage({id: 'section.planning-configuration.dms-link.booking-capacity-limit'})}</h3>
              <div>
                <RadioGroup value={dmsLinkConfiguration && dmsLinkConfiguration.bookingCapacityLimit} disabled={!canWrite} onChange={this.handleDmsLinkBookingCapacityLimitChange}>
                  <RadioButton value={'ONLINE_BOOKING_CAPACITY'}>{formatMessage({id: 'planning-configuration.booking-capacity-limit.ONLINE_BOOKING_CAPACITY'})}</RadioButton>
                  <RadioButton value={'OPEN_BUFFER'}>{formatMessage({id: 'planning-configuration.booking-capacity-limit.OPEN_BUFFER'})}</RadioButton>
                </RadioGroup>
              </div>

              {dmsLinkConfiguration && dmsLinkConfiguration.bookingCapacityLimit === 'ONLINE_BOOKING_CAPACITY' &&
                <React.Fragment>
                  <h3 className='box__subtitle'>{formatMessage({id: 'section.planning-configuration.dms-link.max-online-booking-capacity'})}</h3>
                  <SAInputPercentage
                    name={'maxOnlineBookingCapacity'}
                    value={dmsLinkConfiguration && dmsLinkConfiguration.maxOnlineBookingCapacity}
                    disabled={!canWrite} error={errors['dmsLinkConfiguration.maxOnlineBookingCapacity']}
                    onChange={this.handleDmsLinkMaxOnlineBookingCapacityChange}
                  />
                </React.Fragment>
              }

              {dmsLinkConfiguration && dmsLinkConfiguration.bookingCapacityLimit === 'OPEN_BUFFER' &&
                <React.Fragment>
                  <h3 className='box__subtitle'>{formatMessage({id: 'section.planning-configuration.dms-link.min-open-buffer'})}</h3>
                  <SAInputNumber
                    name={'minOpenBuffer'}
                    value={dmsLinkConfiguration && dmsLinkConfiguration.minOpenBuffer}
                    disabled={!canWrite} min={0} max={1000} error={errors['dmsLinkConfiguration.minOpenBuffer']}
                    onChange={this.handleDmsLinkMinOpenBufferChange}/>
                </React.Fragment>
              }

            </div>
          </div>
        </div>
      </section>

    )
  }
}

const mapStateToProps = (state) => ({
  fetchDealerPlanningConfiguration: selectFetchDealerPlanningConfiguration(state),
  saveDealerPlanningConfiguration: selectSaveDealerPlanningConfiguration(state),
  loading: selectDealerPlanningLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchDealerPlanningConfiguration: () => dispatch(fetchDealerPlanningConfiguration()),
  dispatchSaveDealerPlanningConfiguration: (body) => dispatch(saveDealerPlanningConfiguration(body))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  (Component) => withAuthorization(Component, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR'])
)(PlanningConfiguration);
